module.exports = __WEBPACK_EXTERNAL_MODULE_66__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/Observable"
// module id = 66
// module chunks = 0